import React from 'react';
import { arrayOf, bool, string } from 'prop-types';
import { BulletList } from '../BulletList/BulletList';

export const Highlights = ({ highlights, hideRichContents, showRichContentsOnly }) => {
  // @TODO dont map highlight to value:
  const highlightedBullets = (highlights || []).map((highlight) => ({ value: highlight }));
  if (!highlightedBullets.length) {
    return null;
  }

  return (
    <BulletList
      bullets={highlightedBullets}
      showRichContentsOnly={showRichContentsOnly}
      hideRichContents={hideRichContents}
    />

  );
};

Highlights.displayName = 'ProductOverviewHighlights';

Highlights.propTypes = {
  highlights: arrayOf(string).isRequired,
  hideRichContents: bool,
  showRichContentsOnly: bool
};

Highlights.defaultProps = {
  hideRichContents: false,
  showRichContentsOnly: false
};
